// extracted by mini-css-extract-plugin
export default {"notFound":"Banned_notFound__HQMpM"};